<template>
  <div class="chat-user-card">
    <div class="d-flex align-center"><ChatAvatar :user="user" :size="44" :presence="presence" presence-dot /><div class="ml-3"><strong>{{ name }}</strong><div class="text-caption">{{ user.company_name || (presence && presence.company_name) }}</div></div></div>
    <div class="chat-user-card__status"><span :class="status.color + '--text'">●</span> {{ status.label }}</div>
    <template v-if="presence">
      <div v-if="presence.role" class="text-caption">{{ presence.role }}</div>
      <div v-if="pageLabel" class="text-caption mt-2"><v-icon small>mdi-map-marker-account-outline</v-icon> {{ pageLabel }}</div>
      <div v-if="lastTime" class="text-caption">Dernière consultation : {{ lastTime }}</div>
      <div class="text-caption mt-2">{{ [presence.device, presence.os, presence.browser].filter(Boolean).join(' · ') }}</div>
    </template>
  </div>
</template>
<script>
import ChatAvatar from './ChatAvatar.vue'
import { activity, displayName } from './helpers'
export default {
  components: { ChatAvatar }, props: { user: Object, presence: { default: null }, now: Number },
  computed: {
    name() { return displayName(this.user) }, status() { return activity(this.presence, this.now) },
    pageLabel() {
      const page = this.presence && this.presence.lastpage
      if (!page || !page.id) return ''
      const sameCompany = this.presence.entreprise === this.$store.getters.currentUser.entreprise
      const found = sameCompany && (this.$store.getters.listAll || []).find(p => Number(p.props && p.props.page) === Number(page.id))
      return page.title || (found && found.displayname) || `Page ${page.id}`
    },
    lastTime() { const t = this.presence?.lastpage?.time; return t ? this.moment(t).format('DD/MM HH:mm') : '' }
  }
}
</script>
<style scoped>
.chat-user-card{padding:16px;min-width:240px;max-width:320px}.chat-user-card__status{margin:12px 0 4px;font-size:13px}
</style>
